"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_router_dom_1 = require("react-router-dom");
const apollo_boost_1 = __importDefault(require("apollo-boost"));
const InventoryAdjustmentInfoUIView_1 = __importDefault(require("./ui/InventoryAdjustmentInfoUIView"));
const InventoryAdjustmentInfosUIView_1 = __importDefault(require("./ui/InventoryAdjustmentInfosUIView"));
const client = new apollo_boost_1.default({
    uri: 'api/route/stockManagement',
});
function InventoryAdjustmentRoot() {
    return (react_1.default.createElement(react_hooks_1.ApolloProvider, { client: client },
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/inventoryAdjustment/:id", component: (args) => react_1.default.createElement(InventoryAdjustmentInfoUIView_1.default, Object.assign({ client: client }, args)) }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/inventoryAdjustment", component: InventoryAdjustmentInfosUIView_1.default }))));
}
exports.default = InventoryAdjustmentRoot;
